const Footer = () => {
	return (
		<>
		<footer>
		<p><a href="https://github.com/nvdaes/nvdastore" target="_blank" rel="noopener noreferrer">Source code</a></p>
		<p><a rel="me" href="https://mastodon.chrisduffley.com/@nvdastore">Mastodon</a></p>
		</footer>
		</>
	)
}

export default Footer